import { Component, Input } from '@angular/core';
import { state, style, trigger } from '@angular/animations';

@Component({
  selector: 'app-collapsible-light',
  templateUrl: './collapsible-light.component.html',
  styleUrls: ['./collapsible-light.component.scss'],
  animations: [
    trigger('collapse', [
      state(
        'expanded',
        style({
          maxHeight: '700px',
        })
      ),
      state(
        'collapsed',
        style({
          maxHeight: '{{startHeight}}',
        }),
        {
          params: { startHeight: '0px' },
        }
      ),
    ]),
  ],
})
export class CollapsibleLightComponent {
  @Input() title: string = '';
  @Input() expanded = false;

  toggle(): void {
    this.expanded = !this.expanded;
  }
}
